<script setup lang="ts">
import { ref } from 'vue'
import { useLocalization } from '@/pages-hooks/localization'
import ElSquircleWithText from '../icons/ElSquircleWithText.primitive.vue'

const { locales, defaultLcid } = useLocalization()

interface TProps {
  currentLcid: string
}

const props = defineProps<TProps>()

const popupOpen = ref(false)
const togglePopup = () => {
  popupOpen.value = !popupOpen.value
  if (popupOpen.value) {
    setTimeout(() => {
      popupOpen.value = false
    }, 8000)
  }
}

const getLocalizedDocumentPath = (localeId: string) => {
  // if (!import.meta.browser || !document?.location) {
  //   return `/${props.currentLcid}`
  // }

  // if (document.location.pathname === `/`) {
  //   return `${document.location.pathname}${localeId}`
  // } /*else if (localeId === defaultLcid) {
  //   return document.location.pathname.replace(`/${props.currentLcid}`, `/`)
  // }*/
  let arr = document.location.pathname.split('/').filter((x) => Boolean(x))
  if (arr.length === 0) {
    return `/${localeId}`
  }
  const ids = locales.map((x) => x.id)
  const hasLcid = arr.some((x) => ids.indexOf(x) > -1)
  if (!hasLcid) {
    arr = [localeId, ...arr]
  }
  return `/${arr.map((x) => (ids.indexOf(x) > -1 ? localeId : x)).join('/')}`.replaceAll(/[\/]+/gi, '/')
}

const popupContainerCss =
  `absolute right-0 z-50 mt-2 p-3 origin-top-right` +
  ` rounded-md shadow-md bg-primary content-primary bg-opacity-90` +
  ` ring-1 ring-black ring-opacity-5` +
  ` focus:outline-none`

// keydown.space/keydown.enter are for keyboard accessibility
</script>

<template>
  <div v-if="locales.length > 1" class="relative inline-block text-left">
    <div class="z-50 flex flex-row items-center cursor-pointer">
      <div
        role="button"
        aria-label="Click to change language"
        :aria-expanded="popupOpen"
        tabindex="0"
        class="hover:text-primary"
        @click.prevent="togglePopup"
        @keydown.space.prevent="togglePopup"
        @keydown.enter.prevent="togglePopup"
      >
        <ElSquircleWithText sizeCss="size-5" :text="currentLcid" />
      </div>
    </div>
    <ClientOnly>
      <div v-if="popupOpen" :class="popupContainerCss">
        <div
          role="menu"
          aria-orientation="horizontal"
          class="z-50 flex flex-row items-center gap-x-2 cursor-pointer"
        >
          <a
            v-for="(localeInfo, index) in locales"
            :key="index"
            role="menuitem"
            :aria-label="`Click to select ${localeInfo?.name}`"
            tabindex="0"
            class="cursor-pointer opacity-90 hover:opacity-100"
            :href="`${getLocalizedDocumentPath(localeInfo.id)}`"
          >
            <span class="sr-only">{{ localeInfo.id }}</span>
            <ElSquircleWithText sizeCss="size-6" :text="localeInfo?.id" />
          </a>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>
